function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "01.-Kopsavilkums",
  transform: "translate(-30.000000, -249.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0.000000, 202.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu-item-1",
  transform: "translate(0.000000, 33.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(30.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon-base",
  x: 0,
  y: 0,
  width: 22,
  height: 22,
  rx: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  stroke: "#079DC1",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 1,
  y: 1,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 13,
  y: 1,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 1,
  y: 13,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 13,
  y: 13,
  width: 8,
  height: 8,
  rx: 2
})))))));

function SvgIcSidenavCalendarSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2BB9F898-52C6-446D-8B42-F71A8017CF28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidenavCalendarSelected);
export default __webpack_public_path__ + "static/media/ic-sidenav-calendar-selected.5c4297d9.svg";
export { ForwardRef as ReactComponent };